import { defineMessage, defineMessages } from 'react-intl'

export const healthPlanPaymentMessages = defineMessages({
  creditCardRequirementDisclaimer: {
    defaultMessage:
      'You may have co-pays, co-insurances, or deductibles attached to future sessions. <link>Learn more</link>',
    description:
      'Body text underneath title in cost sharing payment forms. Explains why Lyra needs your credit/debit card information for cost sharing',
  },
  creditCardRequirementDisclaimerSelfPayExtension: {
    defaultMessage:
      'You may have self-pay, no-show, or late cancellation charges attached to future sessions. You’ll only be charged after each session, and we’ll always notify you by email beforehand.',
    description:
      'Body text underneath title in cost sharing payment forms for self-pay extension. Explains why Lyra needs your credit/debit card information for cost sharing',
  },
  creditCardRequirementDisclaimerSelfPayHPIExtension: {
    defaultMessage:
      'You may have copays, co-insurances, deductibles, self-pay, no-show, or late cancellation charges attached to future sessions. You’ll only be charged after each session, and we’ll always notify you by email beforehand.',
    description:
      'Body text underneath title in cost sharing payment forms for self-pay extension. Explains why Lyra needs your credit/debit card information for cost sharing',
  },
  creditCardRequirementDisclaimerEapOnlyNoSelfPay: {
    defaultMessage:
      'You may have no-show or late cancellation charges attached to future sessions. You’ll only be charged after each session, and we’ll always notify you by email beforehand.',
    description:
      'Body text underneath title in payment forms for EAP-only customers without self-pay. Explains why Lyra needs your credit/debit card information for no-show/late cancellation charges',
  },
  creditCardRequirementHPISpecificDisclaimer: {
    defaultMessage:
      'We’ll need this for any out-of-pocket costs, or to collect payments for appointments you miss or cancel within 24 hours. <link>Learn more</link>.',
    description:
      'Body text underneath title in cost sharing payment forms. Explains why Lyra needs your credit/debit card information for cost sharing specifically for HPI care',
  },
  creditCardRequirementHPISpecificDisclaimerTeen: {
    defaultMessage:
      'We’ll need this for any out-of-pocket costs, or to collect payments for appointments your teen misses or cancels within 24 hours. <link>Learn more</link>.',
    description:
      'Body text underneath title in cost sharing payment forms when a parent is booking for their teen. Explains why Lyra needs the credit/debit card information for cost sharing specifically for HPI care',
  },
  creditCardRequirementSelfPayDisclaimer: {
    defaultMessage:
      'You are opting into self-pay using the payment method below. You agree to be responsible for the full cost of each session, plus any charges for late cancellations or no-shows. <link>Learn more.</link>',
    description:
      'Body text underneath title in self-pay payment forms. Explains why Lyra needs your credit/debit card information for self-pay',
  },
  creditCardRequirementSelfPayDisclaimerTeen: {
    defaultMessage:
      'You are opting your teen into self-pay using the payment method below. You agree to be responsible for the full cost of each session, plus any charges for late cancellations or no-shows. <link>Learn more.</link>',
    description:
      'Body text underneath title in self-pay payment forms when a parent is booking for their teen. Explains why Lyra needs the credit/debit card information for self-pay',
  },
  emailBeforeChargeDisclaimer: {
    defaultMessage: 'You’ll only be charged after each session, and we’ll always notify you by email beforehand.',
    description: 'Payment form message informing user they will be emailed before charged',
  },
  lateCancellationOrNoShowDisclaimer: {
    defaultMessage: 'Add a credit or debit card to cover any late-cancellation or no-show payments',
    description:
      'Body text underneath title in infraction payment form. Explains why Lyra needs your credit/debit card information for infractions',
  },
  infractionCardEmptyDescription: {
    defaultMessage:
      "When you're booked with a provider, a valid form of payment is needed to cover late-cancellations and no-show payments.",
    description: 'Text informing the user what payment methods are for',
  },
  infractionCardEmptyDescriptionSelfPay: {
    defaultMessage: 'Once you book a session, provide a payment method for self-pay, late cancellations, or no shows.',
    description: 'Text informing the user what payment methods are for (self-pay extension)',
  },
  infractionCardEmptyDescriptionSelfPayHPI: {
    defaultMessage:
      'Once you book a session, provide a payment method for self-pay, health plan cost share, late cancellations, or no shows.',
    description:
      'Text informing the user what payment methods are for if the customer is HPI only (self-pay extension)',
  },
  infractionCardEmptyDescriptionSelfPayEAP: {
    defaultMessage: 'Once you book a session, provide a payment method for self-pay, late cancellations or no shows.',
    description:
      'Text informing the user what payment methods are for if the customer is EAP only (self-pay extension)',
  },
  healthPlanAddedSuccessMessage: {
    defaultMessage: 'Health plan successfully added',
    description: 'Toast message displayed when a health plan is successfully added',
  },
  paymentMethodUpdatedSuccessMessage: {
    defaultMessage: 'Card updated',
    description: 'Toast message displayed when a payment method is successfully updated',
  },
})

export const defaultHealthPlanDisplayName = defineMessage({
  defaultMessage: 'EPO/PPO plan',
  description: 'Text to denote a default health plan name',
})

export const notEnrolledHealthPlanOption = defineMessage({
  defaultMessage:
    '{searchFor, select, self {I’m not} other {This child isn’t}} enrolled in a {hasCustomerName, select, true {health plan through {customerName}} other {health plan}}',
  description: 'Option text denoting that the user is not enrolled in a health plan',
})
